import { readItem, removeItem, writeItem } from '../../core';

/**
 * profileImage — 프로필 사진의 저장소(client-only).
 *
 * **프로필 객체 안이 아니라 자기 키를 쓴다.** 네이티브 셸은 `localStorage.setItem`
 * 을 가로채 AsyncStorage 로 미러한다(`apps/mobile/src/utils/injectedScripts.ts`) —
 * 사진을 `muzly.profile.v2` 안에 넣으면 닉네임 한 글자를 고칠 때마다 사진까지
 * 통째로 다시 직렬화돼 브릿지를 건넌다. 키를 나누면 사진을 바꿀 때만 사진이 움직인다.
 *
 * 키를 나눈 두 번째 이유는 **나중에 서버로 옮길 자리**를 하나로 모으기 위해서다.
 * 지금은 로컬 전용이고, 서버 계약(`ProfileBody`)에 이미지 필드가 생기면 이 모듈의
 * 세 함수만 바꾸면 된다 — 화면과 프로필 모델은 그대로다.
 *
 * 저장 형식은 data URI 다. `<img src>` 에 그대로 들어가고, 크기는 네이티브 피커가
 * 이미 줄여서 준다(`apps/mobile/src/utils/imagePicker.ts`).
 */

export const PROFILE_IMAGE_KEY = 'muzly.profile.image.v1';

/**
 * 저장할 값이 우리가 쓸 수 있는 이미지 data URI 인가.
 *
 * 브릿지 너머에서 온 문자열이라 형태를 믿지 않는다. 여기서 거르지 않으면 `<img src>`
 * 에 `javascript:` 같은 것이 그대로 들어간다.
 */
export const isImageDataUri = (value: string): boolean =>
  /^data:image\/(png|jpeg|jpg|webp|heic);base64,[A-Za-z0-9+/]+=*$/.test(value);

export const loadProfileImage = (): string | null => {
  const raw = readItem(PROFILE_IMAGE_KEY);
  if (!raw) {
    return null;
  }
  // 예전 형식이나 손상된 값은 버린다 — 마이그레이션 대신 폐기(profile.ts 와 같은 정책).
  if (!isImageDataUri(raw)) {
    removeItem(PROFILE_IMAGE_KEY);
    return null;
  }
  return raw;
};

/** 저장하고, 실제로 저장됐는지 알려 준다. 형식이 아니면 아무것도 안 쓴다. */
export const saveProfileImage = (dataUri: string): boolean => {
  if (!isImageDataUri(dataUri)) {
    return false;
  }
  writeItem(PROFILE_IMAGE_KEY, dataUri);
  return true;
};

export const clearProfileImage = (): void => {
  removeItem(PROFILE_IMAGE_KEY);
};
